// extracted by mini-css-extract-plugin
export default {"resetButton":"G2lacE3","label":"f7_gSTW"};